/** Libellés français des types et sous-types du modèle (app/core/domain/enums.py). */
export const LIBELLE_TYPE: Record<string, string> = {
  client: 'Client',
  supplier: 'Fournisseur',
  web: 'Web',
  mailchimp: 'Mailchimp',
  unknown: 'Non classé',
};

export const LIBELLE_SOUS_TYPE: Record<string, string> = {
  supplier_offer: 'Offre',
  supplier_coc: 'Certificat',
  supplier_fds: 'Fiche de sécurité',
  supplier_invoice: 'Facture',
  supplier_order_confirmation: 'Confirmation de commande',
  payment_reminder: 'Rappel de paiement',
  payment_advice: 'Avis de paiement',
  credit_note: 'Note de crédit',
  quote_request: "Demande d'offre",
  quote_to_enter: 'Offre à saisir',
  client_order: 'Commande',
  client_order_confirmation: 'Confirmation de commande',
  document_request: 'Demande de document',
  internal_request: 'Demande interne',
  sales_journal: 'Journal des ventes',
  mailchimp_no_contact: 'Sans contact',
  mailchimp_generic_contact: 'Contact générique',
  mailchimp_specific_contact: 'Contact nommé',
  web_order: 'Commande web',
  web_info_request: "Demande d'information",
  to_qualify: 'À qualifier',
  unknown: 'Non classé',
};

export const libelleType = (t?: string | null) => (t ? LIBELLE_TYPE[t] || t : 'Non classé');
export const libelleSousType = (t?: string | null) => (t ? LIBELLE_SOUS_TYPE[t] || t.replace(/_/g, ' ') : '');

/**
 * État de lecture d'une ligne, avant toute action : un mail que le pipeline n'a pas
 * fini de lire n'est pas un mail « en cours » s'il a échoué, ou s'il est coincé
 * depuis plus que le seuil du sweeper (15 min).
 */
export type EtatLecture = 'lu' | 'en_cours' | 'bloque' | 'echec' | 'introuvable';

export const SEUIL_BLOCAGE_MIN = 15;

export const etatLecture = (
  e: { status?: string | null; processed_at?: string | null },
  maintenant: number = Date.now(),
): EtatLecture => {
  if (e.status === 'failed') return 'echec';
  // S121 : supprimé ou déplacé à la main avant d'être lu. Ni un échec, ni à relancer.
  if (e.status === 'introuvable') return 'introuvable';
  if (e.status === 'processing') {
    const t = e.processed_at ? Date.parse(e.processed_at) : NaN;
    if (!Number.isNaN(t) && maintenant - t > SEUIL_BLOCAGE_MIN * 60_000) return 'bloque';
    return 'en_cours';
  }
  return 'lu';
};

/** La raison d'un échec de lecture, en une phrase courte. */
export const raisonEchec = (erreur?: string | null): string => {
  const m = erreur || '';
  if (/maximum context length|input_tokens/i.test(m)) return 'Trop long pour le modèle';
  if (/timeout|timed out/i.test(m)) return 'Délai dépassé';
  if (/404/.test(m)) return 'Supprimé ou déplacé de la boîte avant lecture';
  if (/recovery sweeper/i.test(m)) return 'Lecture interrompue, relance en attente';
  return m ? m.slice(0, 80) : 'Lecture impossible';
};
